// Shared support badges/chips (Story #4613) — the one place the request-type,
// priority, and derived-status vocabularies are rendered, so a "Bug" always
// looks the same across the widget, My Tickets, and the admin queue.

import {
  DISPLAY_STATUS_META,
  PRIORITY_BADGE,
  REQUEST_TYPE_BADGE,
  type DisplayStatus,
} from '../../constants/support'
import type { Priority, RequestType } from '../../types/support'

export function RequestTypeBadge({ type }: { type: RequestType }) {
  const meta = REQUEST_TYPE_BADGE[type] ?? REQUEST_TYPE_BADGE.support
  return (
    <span className={`inline-block rounded px-2 py-0.5 text-[11px] font-semibold ${meta.className}`}>
      {meta.label}
    </span>
  )
}

export function PriorityBadge({ priority }: { priority: Priority }) {
  const meta = PRIORITY_BADGE[priority] ?? PRIORITY_BADGE.normal
  return (
    <span className={`inline-block rounded px-2 py-0.5 text-[11px] font-semibold ${meta.className}`}>
      {meta.label}
    </span>
  )
}

export function DisplayStatusChip({ status }: { status: DisplayStatus }) {
  const meta = DISPLAY_STATUS_META[status]
  return (
    <span className={`inline-block rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${meta.className}`}>
      {meta.label}
    </span>
  )
}
